const PermissionsService = {
    hasPermission: (requiredRoles: string[], roles: string[] = []): boolean => {
        if (!requiredRoles || requiredRoles.length === 0) return true;
        if (!roles) return false;

        // Admin / Superuser / Administrator / Operasional role auto-bypass
        const isAdminOrSuperuser = roles.some(role => 
            ['superuser', 'administrator', 'admin', 'superadmin', 'staff', 'operasional'].includes((role || '').toLowerCase())
        );
        if (isAdminOrSuperuser) {
            return true;
        }

        const requiredLower = requiredRoles.map(rr => rr.toLowerCase());
        return roles.some(role => requiredLower.includes((role || '').toLowerCase()));
    }
}

export default PermissionsService;